/**
 * Google Analytics 4, cargado tarde y sin bloquear nada.
 *
 * Por que existe: el sitio solo tenia Clarity, que dice como se usa una pagina pero
 * no cuanta gente llega ni por donde. Sin GA4 no hay forma de saber que guia trajo
 * trafico ni que pagina rinde por anuncio, que es justo la decision que hay que
 * tomar ahora que AdSense esta activo. Vinculado a AdSense, ademas, agrega los
 * ingresos por pagina a los informes.
 *
 * Mismo trato que Clarity y por el mismo motivo: el script de Google pesa y bloquea
 * el hilo principal si arranca durante la evaluacion del chunk compartido. Entra en
 * el primer hueco de inactividad despues del load, con setTimeout de respaldo para
 * Safari, que no trae requestIdleCallback.
 *
 * Si NEXT_PUBLIC_GA_ID esta vacio no se carga nada: ni el script, ni la cookie, ni
 * el aviso de terceros. El sitio funciona igual.
 */
export const GA_ID = process.env.NEXT_PUBLIC_GA_ID ?? ''

export const iniciarAnalitica = () => {
  if (!GA_ID || typeof window === 'undefined') return undefined

  let cancelado = false

  const arrancar = () => {
    if (cancelado || document.getElementById('ga4')) return

    window.dataLayer = window.dataLayer || []

    /*
      gtag tiene que usar `arguments` de verdad: GA lee el objeto arguments tal cual
      lo empuja a dataLayer. Con parametros rest la carga llega como un array y la
      etiqueta no la reconoce.
    */
    window.gtag = function gtag() {
      window.dataLayer.push(arguments)
    }
    window.gtag('js', new Date())

    /*
      config con los valores por defecto, y ninguna vista a mano.

      GA4 trae activado "cambios de pagina basados en eventos del historial del
      navegador" dentro de la medicion mejorada, asi que la etiqueta ya cuenta sola
      las navegaciones de Next, que son pushState. Mandar ademas un page_view desde
      routeChangeComplete daba exactamente el doble: medido, 2 vistas por ruta en
      /troops/, /artifacts/ y /jewels/, y 1 sola en la de entrada.

      Si algun dia se apaga esa opcion en Analytics -> Flujos de datos -> Medicion
      mejorada, hay que volver a mandarlas desde aca; mientras siga encendida, esto
      es lo correcto y lo que menos piezas tiene.
    */
    window.gtag('config', GA_ID)

    const s = document.createElement('script')
    s.id = 'ga4'
    s.async = true
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`
    document.head.appendChild(s)
  }

  const enHueco = () =>
    typeof window.requestIdleCallback === 'function'
      ? window.requestIdleCallback(arrancar, { timeout: 4000 })
      : window.setTimeout(arrancar, 2000)

  if (document.readyState === 'complete') {
    enHueco()
  } else {
    window.addEventListener('load', enHueco, { once: true })
  }

  return () => {
    cancelado = true
  }
}
